const handleFetchEmployerRemarksFulfilled = (state, action) => {
	state.status = 'succeeded';
	state.employerRemarks = action.payload.data;
};

const handleAddEmployerRemarkFulfilled = (state, action) => {
	state.status = 'succeeded';
	state.message = action.payload.message;
	if (Array.isArray(action.payload.data)) {
		state.employerRemarks = state.employerRemarks || [];
		state.employerRemarks.push(...action.payload.data);
	}
};

const handleUpdateEmployerRemarkFulfilled = (state, action) => {
	state.status = 'succeeded';
	state.message = action.payload.message;
	state.employerRemarks = state.employerRemarks.map((remark) =>
		remark.id === action.payload.data[0].id ? action.payload.data[0] : remark
	);
};

const handleDeleteEmployerRemarkFulfilled = (state, action) => {
	state.status = 'succeeded';
	const remarkId = action.payload.data.id;
	state.employerRemarks = state.employerRemarks.filter((remark) => remark.id !== remarkId);
	state.message = action.payload.message;
};

const handleDeleteInsuranceRemarkFulfilled = (state, action) => {
	state.status = 'succeeded';
	const remarkId = action.payload.data.id;
	state.insuranceRemarks = state.insuranceRemarks.filter((remark) => remark.id !== remarkId);
	state.message = action.payload.message;
};

const handleFetchWorkerRemarksFulfilled = (state, action) => {
	state.status = 'succeeded';
	state.workerRemarks = action.payload.data;
};

const handleAddWorkerRemarkFulfilled = (state, action) => {
	state.status = 'succeeded';
	state.message = action.payload.message;
	if (Array.isArray(action.payload.data)) {
		state.workerRemarks = state.workerRemarks || [];
		state.workerRemarks.push(...action.payload.data);
	}
};

const handleUpdateWorkerRemarkFulfilled = (state, action) => {
	state.status = 'succeeded';
	state.message = action.payload.message;
	state.workerRemarks = state.workerRemarks.map((remark) =>
		remark.id === action.payload.data[0].id ? action.payload.data[0] : remark
	);
};

const handleDeleteWorkerRemarkFulfilled = (state, action) => {
	state.status = 'succeeded';
	const remarkId = action.payload.data.id;
	state.workerRemarks = state.workerRemarks.filter((remark) => remark.id !== remarkId);
	state.message = action.payload.message;
};

const handleFetchProcessingRemarksFulfilled = (state, action) => {
	state.status = 'succeeded';
	state.processingRemarks = action.payload.data;
};

const handleAddProcessingRemarkFulfilled = (state, action) => {
	state.status = 'succeeded';
	state.message = action.payload.message;
	if (Array.isArray(action.payload.data)) {
		state.processingRemarks = state.processingRemarks || [];
		state.processingRemarks.push(...action.payload.data);
	}
};

const handleUpdateProcessingRemarkFulfilled = (state, action) => {
	state.status = 'succeeded';
	state.message = action.payload.message;
	state.processingRemarks = state.processingRemarks.map((remark) =>
		remark.id === action.payload.data[0].id ? action.payload.data[0] : remark
	);
};

const handleDeleteProcessingRemarkFulfilled = (state, action) => {
	state.status = 'succeeded';
	const remarkId = action.payload.data.id;
	state.processingRemarks = state.processingRemarks.filter((remark) => remark.id !== remarkId);
	state.message = action.payload.message;
};

const handleFetchInvoiceRemarksFulfilled = (state, action) => {
	state.status = 'succeeded';
	state.invoiceRemarks = action.payload.data;
};

const handleaAdInvoiceRemarksFulfilled = (state, action) => {
	state.status = 'succeeded';
	state.message = action.payload.message;
	state.invoiceRemarks = state.invoiceRemarks || [];
	if (Array.isArray(action.payload.data)) {
		state.invoiceRemarks.push(...action.payload.data);
	} else if (typeof action.payload.data === 'object' && action.payload.data !== null) {
		state.invoiceRemarks = [action.payload.data, ...state.invoiceRemarks];
	}
};

const handleAddInsuranceRemarkFulfilled = (state, action) => {
	state.status = 'succeeded';
	state.message = action.payload.message;
	const r = [{ ...action.payload.data }]
	if (Array.isArray(r)) {
		state.insuranceRemarks = state.insuranceRemarks || [];
		state.insuranceRemarks = [...r, ...state.insuranceRemarks];
	}
};

const handleUpdateInvoiceRemarksFulfilled = (state, action) => {
	state.status = 'succeeded';
	state.message = action.payload.message;
	state.invoiceRemarks = state.invoiceRemarks.map((remark) =>
		remark.id === action.payload.data.id ? action.payload.data : remark
	);
};

const handleDeleteInvoiceRemarkFulfilled = (state, action) => {
	state.status = 'succeeded';
	const remarkId = action.payload.data.id;
	state.invoiceRemarks = state.invoiceRemarks.filter((remark) => remark.id !== remarkId);
	state.message = action.payload.message;
};

const handleUpdateEditInsuranceRemarkFulfilled = (state, action) => {
	state.status = 'succeeded';
	state.message = action.payload.message;
	if (action.payload?.data) {
		state.insuranceRemarks = state.insuranceRemarks.map((remark) =>
			remark.id === action.payload?.data?.id ? action.payload.data : remark
		);
	}

};

export {
	handleFetchEmployerRemarksFulfilled,
	handleAddEmployerRemarkFulfilled,
	handleUpdateEmployerRemarkFulfilled,
	handleDeleteEmployerRemarkFulfilled,
	handleFetchWorkerRemarksFulfilled,
	handleAddWorkerRemarkFulfilled,
	handleUpdateWorkerRemarkFulfilled,
	handleDeleteWorkerRemarkFulfilled,
	handleFetchProcessingRemarksFulfilled,
	handleAddProcessingRemarkFulfilled,
	handleUpdateProcessingRemarkFulfilled,
	handleDeleteProcessingRemarkFulfilled,
	handleFetchInvoiceRemarksFulfilled,
	handleaAdInvoiceRemarksFulfilled,
	handleUpdateInvoiceRemarksFulfilled,
	handleDeleteInvoiceRemarkFulfilled,
	handleDeleteInsuranceRemarkFulfilled,
	handleAddInsuranceRemarkFulfilled,
	handleUpdateEditInsuranceRemarkFulfilled
};
